export default "__VITE_ASSET__CCRS5I1y__"